/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';

import { useMemo } from 'react';
import ControllersGroup from './ControllersGroup';

import { IconChoiceBoxController } from './Base';

import {
  ChartTable,
  ChartBar,
  ChartPie,
  ChartLine,
  ChartWorldMap,
  ChartFunnel,
  ChartRadialBar,
  ChartBoxPlot,
  Reload,
} from '../../icons';

const chartOpts = (theme, advancedChartsAllowed) => ([
  {
    value: 'auto',
    icon: <div style={{ transform: 'rotate(90deg)' }}><Reload fill={theme.primary} /></div>,
    label: 'Seguir o gráfico original',
    id: 'dd-auto',
  },
  {
    value: 'Table',
    icon: <ChartTable primary={theme.primary} secondary={theme.secondary} />,
    label: 'Tabela',
    id: 'dd-table',
  },
  {
    value: 'Bar',
    icon: <ChartBar primary={theme.primary} secondary={theme.secondary} />,
    label: 'Barra',
    id: 'dd-bar',
  },
  {
    value: 'Line',
    icon: <ChartLine primary={theme.primary} secondary={theme.secondary} />,
    label: 'Linha',
    id: 'dd-line',
  },
  {
    value: 'Pie',
    icon: <ChartPie primary={theme.primary} secondary={theme.secondary} />,
    label: 'Pizza',
    id: 'dd-pie',
  },
  {
    value: 'Map',
    icon: <ChartWorldMap primary={theme.primary} secondary={theme.secondary} />,
    label: 'Geográfico',
    id: 'dd-map',
  },
  {
    value: 'Funnel',
    icon: <ChartFunnel primary={theme.primary} secondary={theme.secondary} />,
    label: 'Funil',
    id: 'dd-funnel',
  },
  {
    value: 'RadialBar',
    icon: <ChartRadialBar primary={theme.primary} secondary={theme.secondary} />,
    label: 'Barra Radial',
    id: 'dd-radialbar',
  },
  ...(advancedChartsAllowed ? [{
    value: 'BoxPlot',
    icon: <ChartBoxPlot primary={theme.primary} secondary={theme.secondary} />,
    label: 'Diagrama de Caixa',
    id: 'dd-boxplot',
  }] : []),
]);

const calcGrid = (n) => {
  if (n <= 0) return [1, 1];
  const a = Math.ceil(Math.sqrt(n));
  const b = Math.ceil(n / a);
  return [a, b];
};

const MainDD = ({
  config = undefined,
  handle = () => {},
  extend = '',
  setExtend = () => {},
  advancedChartsAllowed = false,
}) => {
  const theme = useTheme();

  const opts = useMemo(() => chartOpts(theme, advancedChartsAllowed));

  return (
    <>
      <ControllersGroup
        title="Gráfico"
        id="chart"
        extend={extend}
        setExtend={setExtend}
        sizeIncrease={3}
      >
        <span style={{ fontSize: '12px', color: 'gray' }}>
          Para visualizar estes estilos,
          abra um subgráfico clicando em uma categoria do gráfico principal.
        </span>
        <IconChoiceBoxController
          label="Formato de gráfico"
          handle={handle}
          kWord="DrilldownStyle"
          options={opts}
          configValue={config?.DrilldownStyle ?? 'auto'}
          fullWidth
          toggleTooltip
          grid={calcGrid(opts.length ?? 1)}
        />
      </ControllersGroup>
    </>
  );
};

MainDD.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  advancedChartsAllowed: PropTypes.bool,
};

export default MainDD;
